const dirtyEditors = new Set();
export const registerWorkforceDraft = (id, dirty) => dirty ? dirtyEditors.add(id) : dirtyEditors.delete(id);
export const confirmWorkforceAccountChange = () => !dirtyEditors.size || window.confirm('Discard unsaved planning changes and switch accounts?');
